import axios from 'axios'
import { trimObj } from '../collection'
import { addPending, removePending, setObjToUrlParams, ContentType, isAxiosSuccess } from './util'
import qs from 'qs'
import Toast from '@/h5/components/toast'
import { errorCodeLocales } from './errorCode'

const service = axios.create({
  timeout: 50000
})

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    removePending(config) // 在请求开始前，对之前的请求做检查取消操作
    addPending(config) // 将当前请求添加到 pending 中
    // get请求映射params、data
    // 过滤值中存在的前后空格
    if (config.params) {
      config.params = trimObj(config.params)
    }
    if (config.data) {
      config.data = trimObj(config.data)
    }

    if (config.method === 'get' && (config.params || config.data)) {
      config.url = setObjToUrlParams(config.url, Object.assign({}, config.params, config.data))
      config.params = {}
    }

    if (config.headers['Content-Type'] && config.headers['Content-Type'] === ContentType.FORM) {
      config.data = qs.stringify(config.data)
    }
    const token = sessionStorage.getItem('token')
    if (token) {
      config.headers.Authorization = token
    }
    return config
  },
  (error) => {
    // 错误抛到业务代码
    if (error.response) {
      error.response.data.message = '服务器异常，请联系管理员！'
    }
    return Promise.resolve(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data || response
    if (isAxiosSuccess(res)) {
      return res
    } else {
      const errInfo = res ? res.errInfo : ''
      if (errInfo?.code) {
        errorCodeLocales(errInfo.code) && Toast({ message: `${errorCodeLocales(errInfo.code)}` })
      }
      return Promise.reject(errInfo)
    }
  },
  (error) => {
    const methodRegExp = /^(GET|PUT|PATCH|POST)&/i
    if (!methodRegExp.test(error.message)) {
      Toast({ message: `${error.message}` })
    }
    return Promise.reject(error)
  }
)

export default service
